import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../../ReducerRegister";
import EditService from "../../../../../services/screens/admin/composition/aiprompts/EditService";
import { ActionTypes } from "../../../../actionTypes/screens/admin/composition/aiprompts/EditActionTypes";
import AsyncActionReducers from "../../../../AsyncActionReducers";

import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.composition.aiprompts.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: id => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id });

            EditService.loadScreenView(
                id,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    savePromptAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_PROMPT_ASYNC, vo });

            EditService.savePrompt(
                vo,
                response => {
                    dispatch(Actions.savePromptSuccess(response));
                },
                error => {
                    dispatch(Actions.savePromptFailure(error));
                }
            );
        };
    },

    savePromptSuccess: data => ({
        type: ActionTypes.SAVE_PROMPT_SUCCESS,
        parentType: ActionTypes.SAVE_PROMPT_ASYNC,
        data
    }),

    savePromptFailure: error => ({
        type: ActionTypes.SAVE_PROMPT_FAILURE,
        parentType: ActionTypes.SAVE_PROMPT_ASYNC,
        error
    }),

    createPrompt: (productId) => ({
        type: ActionTypes.CREATE_PROMPT,
        productId
    })
};

//
// Initial State
//
const INITIAL_STATE = {
    prompt: null,
    promptWithCategory:null,
    enableLearnFunction: false,
    categories: null,
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, enableLearnFunction: data.enableLearnFunction, prompt: data.enableLearnFunction ? null : data.prompt, promptWithCategory: data.enableLearnFunction ? data.promptWithCategory: null, categories: data.categories };
};

const createPromptReducer = (state, { productId }) => {
    return { ...state, prompt: { productId } };
};


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_PROMPT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_PROMPT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_PROMPT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CREATE_PROMPT]: createPromptReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
